import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"

class TiposDeComprobante extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Abreviatura",
                    id: "abreviatura",
                    accessor: d => d.abreviatura,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'configuracion_tiposdecomprobante_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'configuracion_tiposdecomprobante_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'configuracion_tiposdecomprobante_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'configuracion_tiposdecomprobante_delete',
                    }
                ]}
                apiUrl={api.configuracion.tiposdecomprobante}
                columns={this.state.columns}
                title={"Tipos de Comprobante"}
            />
        );
    }
}

export default TiposDeComprobante;



// WEBPACK FOOTER //
// ./src/views/Configuracion/TiposDeComprobante/TiposDeComprobante.js